import React from 'react'
import PercentageAnswerChoice from './PercentageAnswerChoice'
import shortid from 'shortid'

export default function QuestionPercentage ({number, startingLetter, percents, correct, skill}) {

  const letterList = {
    a: ['A', 'B', 'C', 'D', 'E'],
    f: ['F', 'G', 'H', 'J', 'K'],
  }
  const letters = letterList[startingLetter.toLowerCase()]
  
  let answerChoices = []
  percents.forEach((percent, n) => {
    answerChoices.push(
      <PercentageAnswerChoice
        letter={letters[n]}
        percent={percent}
        key={shortid.generate()}
        correct={correct === n ? true : false}
      />
    )
  })
  
  return (
    <div className="question">
      <div className="question-number">{`${number}.`}</div>
      <div className="answer-choices">
        {answerChoices}
        <p className="question-skill">
          <a href={skill.link}>{skill.name}</a>
        </p>
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/AnswerPercentage/QuestionPercentage.js